import React from "react";
import Icons from "./Icons";

const SocialImpactSection = ({
  section,
  updateSectionItem,
  removeSectionItem,
  addSectionItem,
}) => {
  const getEmptyItem = () => ({
    title: "",
    organization: "",
    description: "",
  });

  return (
    <div className="social-impact-section">
      {section.items?.map((item) => (
        <div key={item.id} className="social-impact-item">
          <button
            onClick={() => removeSectionItem(item.id)}
            className="item-remove-button"
            title="Remove social impact"
          >
            <Icons.X className="w-4 h-4" />
          </button>

          <div className="item-content">
            <div className="form-group">
              <label className="form-label">
                Initiative/Impact Title
                <span className="label-hint">
                  Describe the social cause or initiative
                </span>
              </label>
              <input
                type="text"
                value={item.title || ""}
                onChange={(e) =>
                  updateSectionItem(item.id, { title: e.target.value })
                }
                placeholder="e.g., STEM Education for Underserved Communities"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                Organization
                <span className="label-hint">
                  Optional: Associated organization or group
                </span>
              </label>
              <input
                type="text"
                value={item.organization || ""}
                onChange={(e) =>
                  updateSectionItem(item.id, { organization: e.target.value })
                }
                placeholder="e.g., Code for Good Foundation"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                Description & Impact
                <span className="label-hint">
                  Describe your contribution and the measurable impact
                </span>
              </label>
              <textarea
                value={item.description || ""}
                onChange={(e) =>
                  updateSectionItem(item.id, { description: e.target.value })
                }
                placeholder="e.g., • Developed curriculum for coding bootcamp serving 200+ students
• Mentored 15 students, with 80% securing tech internships
• Raised $10,000 through fundraising initiatives"
                className="form-textarea"
                rows={4}
              />
            </div>
          </div>
        </div>
      ))}

      <button
        onClick={() => addSectionItem(getEmptyItem())}
        className="add-item-button"
      >
        <Icons.Plus className="w-4 h-4" />
        Add Social Impact
      </button>

      {section.items?.length === 0 && (
        <p className="empty-message">
          No social impact initiatives added yet. Showcase how you've made a
          difference in your community.
        </p>
      )}

      <div className="section-tip">
        <p className="tip-text">
          💡 Tip: Include measurable outcomes and specific contributions to
          demonstrate your impact effectively.
        </p>
      </div>
    </div>
  );
};

export default SocialImpactSection;
